// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"573":"630fe58c","907":"2e2c4d16"}[chunkId] + ".chunk.js";
};